import { Carrier } from '@liveauctioneers/hammer-ui-payments/types';

export enum ShippingVisibility {
    Pending = 'pending',
    Unavailable = 'disabled',
    Uncalculated = '',
    Visible = 'enabled',
}

export type ShippingEstimate = {
    actualHandlingAndInsurance: number;
    /**
     * This amount is the shipping fee total, regardless of what the house charges the winning bidder
     * @see {actualHandlingAndInsurance}
     */
    actualTotal: number;
    carrierName: Carrier;
    carrierService: string;
    city: string;
    currency: string;
    /**
     * true if elabel
     *
     * false if full-service
     */
    elabel: boolean;
    expirationDate: string;
    /**
     * Handling and Insurance is an additional fee applied to USPS quotes
     */
    handlingAndInsurance: number;
    /**
     * Is the returned quote flat-rate shipping?
     * Can only be true for elabel estimates
     */
    isFlatRate: boolean;
    message: string;
    quoteId: string;
    quoteNumber: string;
    shippingAvailable: boolean;
    shippingProvider: number;
    state: string;
    /**
     * The amount a bidder will pay if they win (does not include handling and fees)
     * @see {handlingAndInsurance}
     */
    total: number;
    transitDays: number;
    visibility: ShippingVisibility;
};
